<template>
  <div class="frameParent" v-if="student">
    <div class="frameParent1">
      <div class="textParent" v-if="classObj">
        <b class="text"
          >{{
            classObj.startDate.toLocaleDateString("default", { month: "long" })
          }}
          Class</b
        >
        <div class="dateParent">
          <div class="text">
            Start: {{ classObj.startDate.toLocaleDateString() }} | End:
            {{ classObj.endDate.toLocaleDateString() }}
          </div>
        </div>
      </div>
      <div class="frameParent2">
        <img class="frameIcon" alt="" :src="student.image" />
        <div class="frameParent3">
          <div class="studentParent" v-if="classObj">
            <div class="text">
              Student | {{ classObj.curriculum.program.name }} Pilot License
            </div>
          </div>
          <b class="keatonHarris"
            >{{ student.firstName }} {{ student.lastName }}</b
          >
          <div class="frameParent4">
            <!--            <div class="endorsementsWrapper">
              <div class="endorsements">Endorsements</div>
            </div>-->
            <div class="endorsementsWrapper" @click="goToGradebook">
              <div class="endorsements">Grade Book</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tableContainer" v-if="classObj">
      <b>Program Overview</b>
      <div class="tableBorderWrapper">
        <div class="tableWrapper">
          <table>
            <thead>
              <tr>
                <th>Student</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Program</th>
                <th>Status</th>
                <th>Days</th>
                <th>Checkride Date</th>
                <th>Grade</th>
                <th>Precentage</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ student.firstName }} {{ student.lastName }}</td>
                <td>{{ classObj.startDate.toLocaleDateString() }}</td>
                <td>{{ classObj.endDate.toLocaleDateString() }}</td>
                <td>{{ classObj.curriculum.program.name }}</td>
                <td v-if="grades.daysMargin >= 0" class="greenText">Ahead</td>
                <td v-else class="redText">Behind</td>
                <td :class="grades.daysMargin >= 0 ? 'greenText' : 'redText'">
                  {{ grades.daysMargin }} Days
                </td>
                <td></td>
                <td>{{ grades.gradeLetter }}</td>
                <td>{{ grades.averageGrade.toFixed(2) }}%</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="frameWrapper" v-if="todaysLesson">
      <div class="frameParent6">
        <div class="todaysLessonParent">
          <b class="startDate">Today’s Lesson</b>
          <div class="viewAndRefreshContainer">
            <p class="viewAndRefresh">View and refresh your knowledge</p>
            <p class="viewAndRefresh">on what you’re learning.</p>
          </div>
        </div>
        <button class="arrowButton" @click="goToLesson">
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>
    <!--    <div class="frameParent7">
      <div class="courseResourcesWrapper">
        <b class="januaryClass">Course Resources</b>
      </div>
      <div class="lessonWrapper">
        <div class="lesson">
          <div class="documentsWrapper">
            <div class="startDate">Documents</div>
          </div>
          <div class="acsParent">
            <div class="div">ACS</div>
            <div class="frameWrapper1">
              <div class="viewWrapper">
                <div class="januaryClass">View</div>
              </div>
            </div>
          </div>
          <div class="acsParent">
            <div class="januaryClass">PHAK</div>
            <div class="frameWrapper1">
              <div class="viewWrapper">
                <div class="januaryClass">View</div>
              </div>
            </div>
          </div>
          <div class="acsParent">
            <div class="januaryClass">Advisory Circulars</div>
            <div class="frameWrapper1">
              <div class="viewWrapper">
                <div class="januaryClass">View</div>
              </div>
            </div>
          </div>
          <div class="acsParent">
            <div class="januaryClass">FAR-AIM</div>
            <div class="frameWrapper1">
              <div class="viewWrapper">
                <div class="januaryClass">View</div>
              </div>
            </div>
          </div>
          <div class="acsParent">
            <div class="januaryClass">Airplane Flying Handbook</div>
            <div class="frameWrapper1">
              <div class="viewWrapper">
                <div class="januaryClass">View</div>
              </div>
            </div>
          </div>
          <div class="acsParent">
            <div class="div">POH</div>
            <div class="frameWrapper1">
              <div class="viewWrapper">
                <div class="januaryClass">View</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <CourseDetails v-if="loaded" />
  </div>
  <div v-else>No Class Found</div>
</template>
<script>
import dayjs from "dayjs";
import { useLoginStore } from "../../../stores/loginStore";
import { getProcessedImageUrl } from "../../../util/images";
import CourseDetails from "./Classroom/CourseDetails/CourseDetails.vue";
import ClassesAPIService from "@/servicehandlers/ClassesAPIService";
import ActiveStudentsAPIService from "../../../servicehandlers/ActiveStudentsAPIService";

const classAPIService = new ClassesAPIService();
const activeStudentAPIService = new ActiveStudentsAPIService();
export default {
  components: { CourseDetails },
  name: "ClassroomStudent",
  data() {
    return {
      student: null,
      loaded: false,
      classObj: null,
      grades: null,
      todaysLesson: null,
    };
  },
  mounted() {
    this.student = this.useLoginStore().getUser;
    this.student.image = this.getProcessedImageUrl(this.student.image);
    this.getStudentDetails();
  },
  methods: {
    useLoginStore,
    getProcessedImageUrl,
    goToGradebook() {
      this.$router.push({
        name: "Single Student GradeBook",
      });
    },
    getStudentDetails() {
      this.loading = true;
      return activeStudentAPIService
        .getStudentGradeDetails(this.student.id, this.$router)
        .then((response) => {
          this.grades = response;
          this.classObj = response.class;
          this.classObj.startDate = new Date(this.classObj.startDate);
          this.classObj.endDate = new Date(this.classObj.endDate);

          if (!this.$route.query.curriculumId) {
            this.$router.replace({
              query: {
                ...this.$route.query,
                curriculumId: this.classObj.curriculum.id,
              },
            });
          }
          this.loaded = true;

          if (this.grades.averageGrade >= 90) {
            this.grades.gradeLetter = "A";
          } else if (
            this.grades.averageGrade < 90 &&
            this.grades.averageGrade >= 80
          ) {
            this.grades.gradeLetter = "B";
          } else if (
            this.grades.averageGrade < 80 &&
            this.grades.averageGrade >= 70
          ) {
            this.grades.gradeLetter = "C";
          } else if (
            this.grades.averageGrade < 70 &&
            this.grades.averageGrade >= 60
          ) {
            this.grades.gradeLetter = "D";
          } else {
            this.grades.gradeLetter = "F";
          }

          let today = dayjs().add(1, "day");
          for (let stage of this.classObj.curriculum.curriculumStages) {
            for (let lesson of stage.lessons) {
              lesson.dueDate = dayjs(lesson.dueDate);
              if (lesson.dueDate.isSame(today.add(-1, 'day'), "day")) {
                this.todaysLesson = lesson;
              }
            }
          }
        });
    },
    goToLesson() {
      this.$router.push({
        name: "Lesson Student",
        query: {
          lessonId: this.todaysLesson.id,
        },
      });
    },
  },
};
</script>
<style scoped>
.greenText {
  color: #009c74;
}
.redText {
  color: #9c0000;
}
.arrowButton {
  font-size: 30px;
  padding: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.tableContainer {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 50px;
}

.tableWrapper {
  overflow-x: auto;
  display: block;
  width: 100%;
  max-width: 100%;
}

.tableBorderWrapper {
  width: 100%;
}

table {
  width: 100%;
  background-color: white;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  border: none !important;
}

.fadeRight {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: calc(100% - 15px);
  pointer-events: none;
  background: linear-gradient(
    to left,
    rgba(246, 246, 246, 1),
    rgba(246, 246, 246, 0)
  );
  transition: opacity 0.1s ease-in-out;
  opacity: 0;
}

.fadeLeft {
  position: absolute;
  top: 0;
  left: calc(var(--name-column-width) + var(--grade-column-width));
  width: 50px;
  height: calc(100% - 15px);
  pointer-events: none;
  background: linear-gradient(
    to right,
    rgba(246, 246, 246, 1),
    rgba(246, 246, 246, 0)
  );
  transition: opacity 0.1s ease-in-out;
  opacity: 0;
}

th,
td {
  border: 1px solid #929292;
  padding: 8px;
  text-align: center;
  font-size: 15px;
  font-weight: 400 !important;
  width: 10%;
}

th {
  background-color: #696969;
  color: white;
  font-weight: bold;
  border-right: #696969 1px solid;
  border-top: none;
  border-bottom: none;
  border-left: none;
}

th.blueHeader {
  background-color: #3c78ff;
  border-right: #3c78ff 2px solid;
  text-align: center;
  position: sticky;
  left: var(--name-column-width);
  /* Dynamically position Grade */
  z-index: 2;
}

th.orangeHeader,
td.orangeHeader {
  background-color: #ff8800;
  border-right: #d97400 1px solid;
  border-left: #d97400 1px solid;
  border-top: none;
  border-bottom: none;
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 150px !important;
  max-width: 150px !important;
}

th.orangeHeader:first-child {
  border-left: none;
}

td.blueHeader {
  background-color: #f4f7ff;
  text-align: center;
  position: sticky;
  left: var(--name-column-width);
  /* Dynamically position Grade */
  z-index: 2;
}

td.greyHeader {
  background-color: #e3e3e3;
  border-left: 1px solid #929292;
  white-space: nowrap;
  text-align: left;
  padding: 5px 10px;
}

td {
  font-size: 14px;
  border-top: none;
  border-bottom: 1px solid #929292;
  padding: 5px 7.5px;
  text-align: center;
}

th:first-child {
  border-top-left-radius: 10px;
  border-left: none;
}

th:last-child {
  border-top-right-radius: 10px;
  border-right: none;
}

tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

th:nth-child(2),
td:nth-child(2) {
}

.gradePercentage {
  cursor: pointer;
}

.gradePercentage:hover {
  text-decoration: underline;
}

th:first-child,
td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}

.noClick {
  cursor: not-allowed;
}

.tableBorderWrapper {
  border-radius: 10px;
  overflow: hidden;
  max-width: 100%;
}

.majesticonssearchLine {
  width: 24px;
  position: relative;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}

.search {
  position: relative;
  line-height: 25px;
}

.majesticonssearchLineParent {
  flex: 1;
  border-radius: 26px;
  background-color: #f6f6f6;
  height: 40px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 10px;
  box-sizing: border-box;
  gap: 10px;
}

.frameChild {
  width: 40px;
  position: relative;
  height: 40px;
}

.vectorIcon {
  position: absolute;
  height: 66.75%;
  width: 100%;
  top: 17.5%;
  right: 0%;
  bottom: 15.75%;
  left: 0%;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}

.wrapper {
  position: absolute;
  height: 37.5%;
  width: 82.5%;
  top: 6.25%;
  right: -42.5%;
  bottom: 56.25%;
  left: 60%;
  border-radius: 20px;
  background-color: #ff8800;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 3px 5px;
  box-sizing: border-box;
}

.vectorIcon1 {
  position: absolute;
  width: 73.75%;
  top: 4px;
  right: 13.14%;
  left: 13.11%;
  max-width: 100%;
  overflow: hidden;
  height: 32px;
}

.container {
  position: absolute;
  width: 82.5%;
  top: 2.5px;
  right: -42.5%;
  left: 60%;
  border-radius: 20px;
  background-color: #ff8800;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 3px 5px;
  box-sizing: border-box;
}

.unionIcon {
  width: 40px;
  position: relative;
  height: 40px;
  cursor: pointer;
}

.frameDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  font-size: 13px;
  color: #fff;
}

.maleUserIcon {
  width: 40px;
  position: relative;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
}

.hiKeatonParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  font-size: 22px;
  color: #404040;
}

.frameContainer {
  align-self: stretch;
  background-color: #fff;
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 70px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 40px 0px 20px;
  gap: 50px;
}

.vectorIcon2 {
  width: 11.3px;
  position: relative;
  height: 11.3px;
}

.vectorIcon3 {
  width: 12px;
  position: relative;
  height: 12px;
}

.vectorParent {
  align-self: stretch;
  background-color: #ff8800;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
  text-align: left;
  font-size: 15px;
  color: #fff;
  font-family: Inter;
}

.frameGroup {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 8;
  text-align: center;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
}

.text {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.frameItem {
  width: 1px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  height: 15px;
}

.dateParent {
  height: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.5);
}

.textParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
}

.frameIcon {
  width: 150px;
  border-radius: 22.5px;
  height: 150px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
}

.frameChild1 {
  width: 1px;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  height: 29px;
}

.studentParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 0px 10px;
  gap: 20px;
}

.keatonHarris {
  align-self: stretch;
  position: relative;
  font-size: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.endorsements {
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.endorsementsWrapper {
  align-self: stretch;
  flex: 1;
  border-radius: 5px;
  background-color: rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  box-sizing: border-box;
  max-width: 200px;
  cursor: pointer;
}

.frameParent4 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  text-align: center;
  font-size: 15px;
  color: #fff;
}

.frameParent3 {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.frameParent2 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
}

.frameParent1 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 20px;
  z-index: 7;
}

.frameChild2 {
  width: 225px;
  height: 16px;
  object-fit: contain;
}

.studentWrapper {
  align-self: stretch;
  background-color: rgba(64, 64, 64, 0.75);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.keatonHarrisWrapper {
  align-self: stretch;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 37px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  text-align: left;
  color: #404040;
}

.lesson {
  flex: 1;
  background-color: #fff;
  border-top: 0.5px solid rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.startDate {
  position: relative;
}

.div {
  position: relative;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.daysContainer {
  align-self: stretch;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 37px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  text-align: left;
  color: #009c74;
}

.lessonChild {
  align-self: stretch;
  background-color: rgba(64, 64, 64, 0.75);
  height: 37px;
}

.submitWrittenWrapper {
  align-self: stretch;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 37px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.lesson9 {
  flex: 1;
  background-color: #fff;
  border-top: 0.5px solid rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  color: #404040;
}

.lessonParent {
  align-self: stretch;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  border: 0.5px solid #9f9f9f;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  font-size: 15px;
  color: #fff;
}

.frameParent5 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 15px;
  z-index: 6;
}

.viewAndRefresh {
  margin: 0;
}

.viewAndRefreshContainer {
  position: relative;
  font-size: 18px;
}

.todaysLessonParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
}

.vectorIcon4 {
  width: 45px;
  position: relative;
  height: 45px;
  object-fit: contain;
}

.frameParent6 {
  width: 100%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px 20px 20px;
  box-sizing: border-box;
}

.frameWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 50px;
  z-index: 5;
  font-size: 58.6px;
}

.courseResourcesWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
}

.documentsWrapper {
  align-self: stretch;
  background-color: rgba(64, 64, 64, 0.75);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px 10px 20px;
  text-align: center;
  color: #fff;
}

.viewWrapper {
  border-radius: 5px;
  background-color: #3c78ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.frameWrapper1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
}

.acsParent {
  align-self: stretch;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px 5px 20px;
}

.lessonWrapper {
  align-self: stretch;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  border: 0.5px solid #9f9f9f;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  font-size: 15px;
}

.frameParent7 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 15px;
  z-index: 4;
}

.vectorIcon5 {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}

.vectorWrapper {
  width: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.frameParent10 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.frameChild3 {
  width: 147px;
  height: 15px;
  object-fit: contain;
}

.frameParent9 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 0px 0px;
}

.frameChild4 {
  width: 35px;
  background-color: #a148ad;
  height: 37px;
}

.titleWrapper {
  flex: 1;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
}

.typeWrapper {
  width: 84px;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.dayWrapper {
  width: 47px;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.num {
  flex: 1;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.numWrapper {
  width: 59px;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.timeWrapper {
  width: 53px;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.statusContainer {
  width: 63px;
  background-color: #a148ad;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.frameParent12 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  color: #fff;
}

.vectorIcon6 {
  width: 13.3px;
  position: relative;
  height: 1.7px;
}

.vectorContainer {
  align-self: stretch;
  width: 35px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.vectorIcon7 {
  width: 6.7px;
  position: relative;
  height: 3.8px;
  object-fit: contain;
}

.pilotQualificationsParent {
  flex: 1;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
  gap: 5px;
}

.groundWrapper {
  align-self: stretch;
  width: 84px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.wrapper4 {
  align-self: stretch;
  width: 47px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.wrapper5 {
  align-self: stretch;
  width: 59px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.wrapper6 {
  align-self: stretch;
  width: 53px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.vectorIcon8 {
  width: 15px;
  position: relative;
  height: 15px;
}

.vectorFrame {
  align-self: stretch;
  width: 63px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.frameParent13 {
  align-self: stretch;
  border-right: 0.5px solid #9f9f9f;
  border-left: 0.5px solid #9f9f9f;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.frameChild5 {
  align-self: stretch;
  width: 35px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
}

.resourceWrapper {
  align-self: stretch;
  width: 110px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
}

.vectorIcon10 {
  width: 15px;
  position: relative;
  height: 15px;
  object-fit: contain;
}

.whatToKnowForThisGroundParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.optional {
  position: relative;
  color: rgba(64, 64, 64, 0.5);
}

.frameParent15 {
  flex: 1;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 15px 5px 10px;
}

.dueTodayWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: rgba(64, 64, 64, 0.5);
}

.vectorWrapper4 {
  width: 35px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.simulatorIntroductionParent {
  flex: 1;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
  gap: 5px;
}

.simulatorWrapper {
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
}

.wrapper7 {
  width: 47px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.wrapper8 {
  width: 59px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.wrapper9 {
  width: 53px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.vectorWrapper5 {
  width: 63px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.quizWrapper {
  align-self: stretch;
  width: 84px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
}

.flightWrapper {
  width: 84px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
}

.wrapper13 {
  width: 47px;
  background-color: #fff;
  border-right: 0.3px solid rgba(64, 64, 64, 0.5);
  border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
  border-left: 0.5px solid rgba(64, 64, 64, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
}

.frameParent34 {
  align-self: stretch;
  border-right: 0.5px solid #9f9f9f;
  border-bottom: 0.5px solid #9f9f9f;
  border-left: 0.5px solid #9f9f9f;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.frameParent11 {
  align-self: stretch;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 15px;
}

.frameParent8 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 15px;
  z-index: 3;
}

.frameChild15 {
  width: 35px;
  background-color: #ff8400;
  height: 37px;
}

.titleContainer {
  flex: 1;
  background-color: #ff8400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
}

.typeContainer {
  width: 84px;
  background-color: #ff8400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.dayContainer {
  width: 47px;
  background-color: #ff8400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.numContainer {
  width: 59px;
  background-color: #ff8400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.timeContainer {
  width: 53px;
  background-color: #ff8400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.statusFrame {
  width: 63px;
  background-color: #ff8400;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.frameParent36 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 15px;
  z-index: 2;
}

.frameChild26 {
  width: 35px;
  background-color: #0062ff;
  height: 37px;
}

.titleFrame {
  flex: 1;
  background-color: #0062ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
}

.typeFrame {
  width: 84px;
  background-color: #0062ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.dayFrame {
  width: 47px;
  background-color: #0062ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.numFrame {
  width: 59px;
  background-color: #0062ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.timeFrame {
  width: 53px;
  background-color: #0062ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.statusWrapper1 {
  width: 63px;
  background-color: #0062ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  box-sizing: border-box;
}

.frameParent64 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 50px;
  gap: 15px;
  z-index: 1;
}

.frameChild36 {
  width: 100px;
  position: relative;
  background-color: #f6f6f6;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 0;
}

.frameParent {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 25px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
